<div class="bg-third-level border-themed h-full rounded-md border p-3.5">
  <div class="text-muted-color text-sm">{{ labelKey() | transloco }}</div>
  <div class="my-2 text-3xl font-bold" [ngClass]="valueClass()">{{ value() }}</div>
  @if (hasBar()) {
    <app-rfi-coverage-bar [percent]="barPercent() ?? 0" trackClass="bg-second-level" />
  }
  @if (noteKey()) {
    <div class="text-muted-color text-sm">{{ noteKey() | transloco: noteParams() }}</div>
  }
</div>
